export default "__VITE_ASSET__DgSTOmD$__"